import { render, staticRenderFns } from "./RegisterFormField.vue?vue&type=template&id=6014f37c&"
import script from "./RegisterFormField.vue?vue&type=script&lang=js&"
export * from "./RegisterFormField.vue?vue&type=script&lang=js&"
import style0 from "./RegisterFormField.vue?vue&type=style&index=0&id=6014f37c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QInput from 'quasar/src/components/input/QInput.js';
import QField from 'quasar/src/components/field/QField.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QInput,QField,QSelect,QBtn,QTooltip,QDialog,QCard,QCardSection,QCardActions});qInstall(component, 'directives', {ClosePopup});
